import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class UpdateBijbAccountErrorAction implements Action {
  public static readonly type = 'UpdateBijbAccountErrorAction';

  constructor(public error: BijbError) {
  }

  public type = UpdateBijbAccountErrorAction.type;
}
